import React, { useState } from 'react';

const ApplicationForm = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [contactData, setContactData] = useState({
    nome: '',
    email: '',
    telefone: '',
    especialidade: ''
  });
  
  const [questionsData, setQuestionsData] = useState({
    pergunta1: '',
    pergunta2: '',
    pergunta3: '',
    pergunta4: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contactSubmitted, setContactSubmitted] = useState(false);

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleQuestionsChange = (e) => {
    const { name, value } = e.target;
    setQuestionsData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('https://ogh5izcvmqvw.manus.space/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'contact_data',
          ...contactData
        }),
      });

      if (response.ok) {
        setContactSubmitted(true);
        setCurrentStep(2);
      } else {
        throw new Error('Erro ao enviar dados de contato');
      }
    } catch (error) {
      console.error('Erro ao enviar dados de contato:', error);
      alert('Erro ao enviar dados de contato. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleQuestionsSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('https://ogh5izcvmqvw.manus.space/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'questions_data',
          contact: contactData,
          questions: questionsData
        }),
      });

      if (response.ok) {
        alert('Sua inscrição foi recebida com sucesso! Entraremos em contato em breve.');
        onClose();
      } else {
        throw new Error('Erro ao enviar respostas');
      }
    } catch (error) {
      console.error('Erro ao enviar respostas:', error);
      alert('Erro ao enviar respostas. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const goBackToStep1 = () => {
    setCurrentStep(1);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-sans font-bold text-primary">Inscrição para Mentoria</h2>
              <p className="text-sm text-gray-600 mt-1">Etapa {currentStep} de 2</p>
            </div>
            <button 
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Indicador de progresso */}
          <div className="mt-4">
            <div className="flex items-center">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${currentStep >= 1 ? 'bg-secondary text-primary-dark' : 'bg-gray-200 text-gray-600'}`}>
                1
              </div>
              <div className={`flex-1 h-1 mx-2 ${currentStep >= 2 ? 'bg-secondary' : 'bg-gray-200'}`}></div>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${currentStep >= 2 ? 'bg-secondary text-primary-dark' : 'bg-gray-200 text-gray-600'}`}>
                2
              </div>
            </div>
            <div className="flex justify-between mt-2 text-sm text-gray-600">
              <span>Dados de Contato</span>
              <span>Perguntas de Qualificação</span>
            </div>
          </div>
        </div>
        
        <div className="p-6">
          {currentStep === 1 && (
            <>
              <p className="text-gray-700 mb-6">
                Primeiro, precisamos dos seus dados de contato para que possamos entrar em contato com você.
              </p>
              
              <form onSubmit={handleContactSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="nome" className="block text-primary font-medium mb-2">Nome completo</label>
                    <input 
                      type="text" 
                      id="nome"
                      name="nome"
                      value={contactData.nome}
                      onChange={handleContactChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="Seu nome completo"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-primary font-medium mb-2">E-mail</label>
                    <input 
                      type="email" 
                      id="email"
                      name="email"
                      value={contactData.email}
                      onChange={handleContactChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="seu.email@exemplo.com"
                      required
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="telefone" className="block text-primary font-medium mb-2">Telefone</label>
                    <input 
                      type="tel" 
                      id="telefone"
                      name="telefone"
                      value={contactData.telefone}
                      onChange={handleContactChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="(00) 00000-0000"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="especialidade" className="block text-primary font-medium mb-2">Especialidade médica</label>
                    <input 
                      type="text" 
                      id="especialidade"
                      name="especialidade"
                      value={contactData.especialidade}
                      onChange={handleContactChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="Sua especialidade"
                      required
                    />
                  </div>
                </div>
                
                <div className="flex justify-end pt-4">
                  <button 
                    type="button" 
                    onClick={onClose}
                    className="mr-4 px-6 py-3 border border-gray-300 rounded-full text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                    disabled={isSubmitting}
                  >
                    Cancelar
                  </button>
                  <button 
                    type="submit" 
                    className="bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft disabled:opacity-50"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Enviando...' : 'Continuar'}
                  </button>
                </div>
              </form>
            </>
          )}

          {currentStep === 2 && (
            <>
              <p className="text-gray-700 mb-6">
                Agora, responda às perguntas abaixo para que possamos avaliar sua candidatura para a mentoria.
              </p>
              
              <form onSubmit={handleQuestionsSubmit} className="space-y-6">
                <div className="space-y-6">
                  <div>
                    <label htmlFor="pergunta1" className="block text-primary font-medium mb-2">1. Por que você acha que a minha mentoria é ideal para você?</label>
                    <textarea 
                      id="pergunta1"
                      name="pergunta1"
                      value={questionsData.pergunta1}
                      onChange={handleQuestionsChange}
                      rows="4" 
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="Descreva suas razões..."
                      required
                    ></textarea>
                  </div>
                  
                  <div>
                    <label htmlFor="pergunta2" className="block text-primary font-medium mb-2">2. Por que, dentre todas as pessoas interessadas nesse programa, eu deveria escolher você para a mentoria?</label>
                    <textarea 
                      id="pergunta2"
                      name="pergunta2"
                      value={questionsData.pergunta2}
                      onChange={handleQuestionsChange}
                      rows="4" 
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="Descreva seus diferenciais..."
                      required
                    ></textarea>
                  </div>
                  
                  <div>
                    <label htmlFor="pergunta3" className="block text-primary font-medium mb-2">3. O valor da mentoria é 30k, você tem capacidade financeira de fazer esse investimento agora?</label>
                    <textarea 
                      id="pergunta3"
                      name="pergunta3"
                      value={questionsData.pergunta3}
                      onChange={handleQuestionsChange}
                      rows="4" 
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="Descreva sua situação financeira..."
                      required
                    ></textarea>
                  </div>
                  
                  <div>
                    <label htmlFor="pergunta4" className="block text-primary font-medium mb-2">4. O que precisa ter acontecido ao final da mentoria para você acreditar que valeu o investimento?</label>
                    <textarea 
                      id="pergunta4"
                      name="pergunta4"
                      value={questionsData.pergunta4}
                      onChange={handleQuestionsChange}
                      rows="4" 
                      className="w-full px-4 py-3 rounded-lg border border-neutral-medium focus:border-primary focus:outline-none transition-colors"
                      placeholder="Descreva suas expectativas..."
                      required
                    ></textarea>
                  </div>
                </div>
                
                <div className="flex justify-between pt-4">
                  <button 
                    type="button" 
                    onClick={goBackToStep1}
                    className="px-6 py-3 border border-gray-300 rounded-full text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                    disabled={isSubmitting}
                  >
                    Voltar
                  </button>
                  <div className="flex">
                    <button 
                      type="button" 
                      onClick={onClose}
                      className="mr-4 px-6 py-3 border border-gray-300 rounded-full text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                      disabled={isSubmitting}
                    >
                      Cancelar
                    </button>
                    <button 
                      type="submit" 
                      className="bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft disabled:opacity-50"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Enviando...' : 'Enviar Inscrição'}
                    </button>
                  </div>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApplicationForm;

